export type Platform = 'windows' | 'linux'

export type DownloadItem = {
  label: string
  filename: string
  url: string
}

export type PlatformDownloads = {
  windows: DownloadItem[]
  linux: DownloadItem[]
}

export type VozillaRelease = {
  version: string
  publishedAt: string | null
  downloads: PlatformDownloads
}

function assetUrl(baseUrl: string, channel: string, filename: string): string {
  return `${baseUrl.replace(/\/+$/, '')}/vozilla/${encodeURIComponent(channel)}/${encodeURIComponent(filename)}`
}

/** Build download entries using the artifact names emitted by electron-builder.js. */
export function createVozillaRelease(
  version: string,
  publishedAt: string | null,
  releaseDistributionBaseUrl: string,
  channel = 'main'
): VozillaRelease {
  const windowsFilename = `theseus-vozilla-${version}-setup.exe`
  const debFilename = `theseus-vozilla_${version}_amd64.deb`
  const appImageFilename = `theseus-vozilla-${version}.AppImage`

  return {
    version,
    publishedAt,
    downloads: {
      windows: [
        {
          label: 'Windows Installer',
          filename: windowsFilename,
          url: assetUrl(releaseDistributionBaseUrl, channel, windowsFilename),
        },
      ],
      linux: [
        {
          label: 'Linux .deb (x64)',
          filename: debFilename,
          url: assetUrl(releaseDistributionBaseUrl, channel, debFilename),
        },
        {
          label: 'Linux AppImage',
          filename: appImageFilename,
          url: assetUrl(releaseDistributionBaseUrl, channel, appImageFilename),
        },
      ],
    },
  }
}

export function getPrimaryDownload(downloads: PlatformDownloads, platform: Platform): DownloadItem | null {
  const platformDownloads = downloads[platform]
  if (platformDownloads.length === 0) return null
  if (platform === 'linux') {
    return platformDownloads.find((download) => download.filename.endsWith('.deb')) ?? platformDownloads[0]
  }
  return platformDownloads[0]
}
